import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COMPANIES_ITEM: {},
  COMPANIES_LIST: [],
  COMPANIES_TABLE_DATA: [],
  COMPANIES_ARRAY_DATA: [],
  COMPANIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_COMPANIES_ITEM: (state) => {
    return state.COMPANIES_ITEM;
  },
  GET_COMPANIES_LIST: (state) => {
    return state.COMPANIES_LIST;
  },
  GET_COMPANIES_TABLE_DATA: (state) => {
    return state.COMPANIES_TABLE_DATA;
  },
  GET_COMPANIES_ARRAY_DATA: (state) => {
    return state.COMPANIES_ARRAY_DATA;
  },
  GET_COMPANIES_TOTAL_ROWS: (state) => {
    return state.COMPANIES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_COMPANIES_ITEM(state, item) {
    state.COMPANIES_ITEM = item;
  },

  UPDATE_COMPANIES_LIST(state, list) {
    
    state.COMPANIES_LIST = list.data;

    state.COMPANIES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.COMPANIES_TABLE_DATA = [];
    state.COMPANIES_ARRAY_DATA = [];

    list.forEach(el => {

      state.COMPANIES_TABLE_DATA.push({
        'uuid'    : el.uuid,
        'id'      : el.id,
        'name'    : el.name,
        'inn'     : el.inn,
        'kpp'     : el.kpp,
        'address' : el.address,
        'comments': el.comments,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,        
        'registration_address': el.registration_address,
        'phone': el.phone,
      });

      state.COMPANIES_ARRAY_DATA.push({
        id: el.id,
        name: el.name,
        account_id: el.account_id,
      });
    });
  },
}

export const actions = {

  async FETCH_COMPANIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/companies/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COMPANIES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_COMPANIES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/companies';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COMPANIES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_COMPANIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/companies';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_COMPANIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/companies/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_COMPANIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/companies/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}